import React, {useContext} from 'react';
import {BridleContext} from '../BridleContextProvider';
import {findMatchingProductFromProductId} from '../HelperFunctions';
import ReviewItem from './ReviewItem';
import ReviewSkipItem from './ReviewSkipItem';

const ProductReview = () => {
    const {options, products} = useContext(BridleContext);

    const bridleProducts = Object.assign({}, options);
    delete bridleProducts['Color'];

    const bridlePieces = Object.entries(bridleProducts);

    return (
        <>
            <div className="review-accordion">Custom Bridle Summary</div>
            <div data-showhide="panel">
                <div className="content product-content">
                    {bridlePieces &&
                        bridlePieces.map(([key, item], index) => {
                            const productId = item.productId;
                            const productDetail = findMatchingProductFromProductId(productId, products);
                            return productDetail ? (
                                <ReviewItem name={key} productDetail={productDetail} key={index} />
                            ) : (
                                <ReviewSkipItem name={key} key={index} />
                            );
                        })}
                </div>
            </div>
        </>
    );
};

export default ProductReview;
